import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "./locales/en/translation.json";
import translationTR from "./locales/tr/translation.json";

const resources = {
  en: { translation: translationEN },
  tr: { translation: translationTR },
};

const savedLanguage = window.localStorage.getItem("kaed-language");

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage === "en" ? "en" : "tr",
    fallbackLng: "tr",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
